export const faqs = [
    {
        title: "Apa itu Sistem Antrian Klinik Berbasis Online?",
        body: "Sistem Antrian Klinik berbasis online adalah layanan digital yang membantu klinik mengelola antrian pasien secara otomatis, real-time, dan terintegrasi melalui website tanpa perlu pencatatan manual.",
    },
    {
        title: "Mengapa Klinik Perlu Sistem Antrian Ini?",
        body: "Sistem ini membantu mengurangi antrian menumpuk, mempercepat pelayanan, meminimalkan kesalahan pencatatan, serta meningkatkan kenyamanan pasien dan efisiensi operasional klinik.",
    },
    {
        title: "Apakah Data Pasien Aman?",
        body: "Keamanan data adalah prioritas kami. Semua data disimpan dengan sistem keamanan yang terjamin dan hanya dapat diakses oleh pihak yang berwenang di klinik Anda.",
    },
    {
        title: "Bagaimana Jika Masa Berlangganan Habis?",
        body: "Jika masa berlangganan habis, sistem akan otomatis nonaktif sementara. Anda dapat memperpanjang langganan kapan saja tanpa kehilangan data.",
    },
];
